import { useSelector, shallowEqual } from 'react-redux';
import { State } from 'store/store';

export const useFreshProps = (
  id: string,
  checkShallowEqual?: undefined | boolean
) => {
  return useSelector(
    (state: State) => {
      return state?.blocks[id]?.props || {};
    },
    checkShallowEqual ? shallowEqual : () => false
  );
};
